export default __webpack_public_path__ + "static/vision01-7fe3ba067514148833618a6e58715759.jpg";